import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';
import { useLoadRangeAtStartTs } from '../range/useLoadRangeAtStartTs';

export function useJumpStream() {
  const range = useStreamUserDefinedRange();
  const loadRangeAtTs = useLoadRangeAtStartTs();

  return (ms: number) => {
    return loadRangeAtTs(range.from + ms);
  };
}
